import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const SET_REUNION_CONFIRMATION = gql`
  mutation Post($reunionId: String!, $setTo: String) {
    setReunionConfirmation(reunionId: $reunionId, setTo: $setTo ) {
      result
      error
      operation
    }
}`;

const setReunionConfirmation = async (formData) => {
  try {
    const result = await clientWeb.mutate({
      mutation: SET_REUNION_CONFIRMATION,
      variables: {
        ...formData,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { setReunionConfirmation: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: setReunionConfirmation Error: ${error}`);
    return null;
  }
};

export default setReunionConfirmation;
